import { render, staticRenderFns } from "./regionIndex.vue?vue&type=template&id=b7f6fc50&scoped=true"
import script from "./regionIndex.vue?vue&type=script&lang=js"
export * from "./regionIndex.vue?vue&type=script&lang=js"
import style0 from "./regionIndex.vue?vue&type=style&index=0&id=b7f6fc50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f6fc50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f6fc50')) {
      api.createRecord('b7f6fc50', component.options)
    } else {
      api.reload('b7f6fc50', component.options)
    }
    module.hot.accept("./regionIndex.vue?vue&type=template&id=b7f6fc50&scoped=true", function () {
      api.rerender('b7f6fc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/falseSignDailyReport/component/regionIndex.vue"
export default component.exports